function divCtrlInit(el) {
    if (el.querySelector('select')) {
        el.classList.add('contains-select');
    }

    const labelElements = el.querySelectorAll('label');
    labelElements.forEach(function (label) {
        label.addEventListener('click', function (event) {
            var previousInput = label.previousElementSibling;
            if (previousInput && (previousInput.tagName === 'INPUT' || previousInput.tagName === 'SELECT')) {
                previousInput.focus();
            }
            event.preventDefault();
        });
    });

    const inputElements = el.querySelectorAll('input, select');
    inputElements.forEach((inputElement) => {
        inputElement.addEventListener('focus', (event) => divCtrlFocus(event.target));
        inputElement.addEventListener('blur', (event) => divCtrlBlur(event.target));
        inputElement.addEventListener('keyup', (event) => divCtrlChange(event.target));
        divCtrlCheckState(inputElement);
    });
}

function divCtrlFocus(ev) {
    ev.parentNode.classList.add('focused');
    divCtrlCheckState(ev);
}

function divCtrlBlur(ev) {
    ev.parentNode.classList.remove('focused');
    divCtrlCheckState(ev);
}

function divCtrlChange(ev) {
    divCtrlCheckState(ev);
}

function divCtrlCheckState(ev) {
    var placeholderText = ev.getAttribute('placeholder');
    if (!placeholderText) {
        const label = ev.nextElementSibling;
        if (label && label.tagName.toLowerCase() === 'label') {
            placeholderText = label.textContent;
            if (placeholderText) ev.setAttribute('placeholder', placeholderText);
        }
    }

    if (ev.hasAttribute('required') && (!placeholderText || !divCtrlEndsWith(placeholderText, ' *'))) {
        placeholderText += ' *';
        ev.setAttribute('placeholder', placeholderText);
    }

    if (ev.value || ev.tagName.toLowerCase() === 'select') {
        ev.parentNode.classList.add('filled');
        ev.parentNode.classList.remove('empty');
    } else {
        ev.parentNode.classList.remove('filled');
        ev.parentNode.classList.add('empty');
    }
}

function divCtrlEndsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

function divCtrlRecalculateSliderBoxes() {
    document.querySelectorAll('.slider-checkbox').forEach(function (sliderCheckbox) {
        var inputHeight = sliderCheckbox.querySelector('input').offsetHeight;
        if (inputHeight < 20) inputHeight = 20;

        const labelHeight = sliderCheckbox.querySelector('label:nth-of-type(2)').offsetHeight;
        const max = Math.max(inputHeight, labelHeight);
        sliderCheckbox.style.height = max + 'px';
    });
}

function RecalculateAllFloatLabelControls() {
    document.querySelectorAll('div.float-label').forEach(divCtrlInit);
    divCtrlRecalculateSliderBoxes();
}

function CopyCode(event) {
    const codeFrame = event.target.closest('.code-frame');
    if (codeFrame) {
        // Get the code text
        const codeElement = codeFrame.querySelector('.code');
        let codeText = '';

        codeElement.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                codeText += node.textContent;
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName === 'BR') {
                    codeText += '\n';
                } else {
                    codeText += node.textContent;
                }
            }
        });

        const processedText = codeText
            .split('\n')  // Split by newlines
            .map(line => line.trim())  // Trim each line
            .filter(line => line.length > 0)  // Remove blank lines
            .join('\n');  // Join lines back together

        navigator.clipboard.writeText(processedText).then(() => {
            const button = event.target;
            button.classList.add('copied');
            button.textContent = 'Copied';

            // Remove the 'copied' class after 1.5 seconds
            setTimeout(() => {
                button.classList.remove('copied');
                button.textContent = 'Copy';
            }, 1500);

        }).catch(err => {
            console.error('Could not copy text: ', err);
        });
    }
}


document.addEventListener('DOMContentLoaded', function () {
    RecalculateAllFloatLabelControls();
});


window.addEventListener('resize', divCtrlRecalculateSliderBoxes);
